export interface TomeMeta {
    id: string;
    title: string;
    subtitle: string;
    author: string;
    series: string;
    spineColor: string;
    spineTextColor: string;
    path: string;
    seo: {
        title: string;
        description: string;
        canonical: string;
    };
}

export const TOMES: TomeMeta[] = [
    {
        id: "black-magic-tome-i",
        title: "Black Magic",
        subtitle: "Tome I — The Basis",
        author: "Neth, Wizard",
        series: "Black Magic",
        spineColor: "#2a0000",
        spineTextColor: "#c8a96e",
        path: "/library/black-magic-tome-i",
        seo: {
            title: "Black Magic, Tome I — Brigobaen Library | Oberin",
            description:
                "Read Black Magic Tome I: The Basis by Neth in the Brigobaen Library. An in-depth study of the origins, mechanics, and spells of Black Magic in the world of Oberin.",
            canonical: "https://www.oberin.be/library/black-magic-tome-i",
        },
    },
    {
        id: "black-magic-tome-ii",
        title: "Black Magic",
        subtitle: "Tome II — The Side-Effects",
        author: "Neth, Black Magician",
        series: "Black Magic",
        spineColor: "#1a0a1a",
        spineTextColor: "#c8a96e",
        path: "/library/black-magic-tome-ii",
        seo: {
            title: "Black Magic, Tome II — Brigobaen Library | Oberin",
            description:
                "Read Black Magic Tome II: The Side-Effects by Neth, with missing pages deciphered by Cecil. Discover the dark consequences of wielding Black Magic in Oberin.",
            canonical: "https://www.oberin.be/library/black-magic-tome-ii",
        },
    },
    {
        id: "on-magic-users",
        title: "On Magic Users",
        subtitle: "",
        author: "Anonymous, transl. by Birek McCalla",
        series: "Arcane Studies",
        spineColor: "#1a2a3a",
        spineTextColor: "#c8d8e8",
        path: "/library/on-magic-users",
        seo: {
            title: "On Magic Users — Brigobaen Library | Oberin",
            description:
                "Read On Magic Users in the Brigobaen Library — an anonymous essay exploring the nature of magic, its users, and magical creatures of the world of Oberin.",
            canonical: "https://www.oberin.be/library/on-magic-users",
        },
    },
    {
        id: "historical-mythology-tome-i",
        title: "Historical Mythology",
        subtitle: "Tome I — The Unbalancing",
        author: "Cecil, Historian of Brigobaen",
        series: "Historical Mythology",
        spineColor: "#2a1a00",
        spineTextColor: "#e8d5a3",
        path: "/library/historical-mythology-tome-i",
        seo: {
            title: "Historical Mythology, Tome I — Brigobaen Library | Oberin",
            description:
                "Read Historical Mythology Tome I: The Unbalancing by Cecil of Brigobaen. Explore the creation of Oberin and the first great Unbalancing that drove Man underground.",
            canonical:
                "https://www.oberin.be/library/historical-mythology-tome-i",
        },
    },
    {
        id: "historical-mythology-tome-ii",
        title: "Historical Mythology",
        subtitle: "Tome II — Haven",
        author: "Cecil, Historian of Brigobaen",
        series: "Historical Mythology",
        spineColor: "#2a1a00",
        spineTextColor: "#e8d5a3",
        path: "/library/historical-mythology-tome-ii",
        seo: {
            title: "Historical Mythology, Tome II — Brigobaen Library | Oberin",
            description:
                "Read Historical Mythology Tome II: Haven by Cecil of Brigobaen. Follow Man's desperate flight underground and the creation of a hidden Haven in the world of Oberin.",
            canonical:
                "https://www.oberin.be/library/historical-mythology-tome-ii",
        },
    },
    {
        id: "historical-mythology-tome-iii",
        title: "Historical Mythology",
        subtitle: "Tome III — Emergence from Haven",
        author: "Cecil, Historian of Brigobaen",
        series: "Historical Mythology",
        spineColor: "#2a1a00",
        spineTextColor: "#e8d5a3",
        path: "/library/historical-mythology-tome-iii",
        seo: {
            title: "Historical Mythology, Tome III — Brigobaen Library | Oberin",
            description:
                "Read Historical Mythology Tome III: Emergence from Haven by Cecil of Brigobaen. Discover how the mage Elara led Man back into the light of Oberin.",
            canonical:
                "https://www.oberin.be/library/historical-mythology-tome-iii",
        },
    },
    {
        id: "historical-mythology-tome-iv",
        title: "Historical Mythology",
        subtitle: "Tome IV — The New Order",
        author: "Cecil, Head Cleric of Brigobaen",
        series: "Historical Mythology",
        spineColor: "#2a1a00",
        spineTextColor: "#e8d5a3",
        path: "/library/historical-mythology-tome-iv",
        seo: {
            title: "Historical Mythology, Tome IV — Brigobaen Library | Oberin",
            description:
                "Read Historical Mythology Tome IV: The New Order by Cecil of Brigobaen. Learn how Elara and her seven Disciples founded the cities of Oberin and ushered in a golden age.",
            canonical:
                "https://www.oberin.be/library/historical-mythology-tome-iv",
        },
    },
];
